/**
 * De legenda onder een grafiek, buiten het tekengebied.
 *
 * Niet die van recharts, en dat is de hele reden dat dit bestand bestaat.
 * `<Legend>` wordt binnen het tekengebied gezet en krijgt daar een vaste hoogte
 * toegewezen. Dat werkt bij korte reeksnamen, maar een hoofdonderwerp heet hier
 * "Vakinhoudelijke verdieping Maintenance Engineering (incl. IAM)": vijf labels
 * van die lengte lopen over meerdere regels, worden hoger dan hun reservering en
 * schuiven over de maandlabels van de x-as heen, waarbij de laatste rechts buiten
 * de kaart valt.
 *
 * Buiten de ChartContainer mag de legenda zo hoog worden als hij nodig heeft, en
 * groeit de kaart mee. De namen blijven dus voluit staan; ze worden niet afgekapt.
 *
 * De kleur komt hier uit `--chart-N` en niet uit `--color-<id>`. Die tweede zet
 * `ChartStyle` op de container zelf, dus buiten de grafiek bestaat hij niet. De
 * volgorde van `reeksen` bepaalt de kleur, precies zoals in de `ChartConfig` van
 * de grafiek erboven, zodat een kleur in beide hetzelfde onderwerp aanwijst.
 */
export function Legenda({ reeksen }: { reeksen: ReadonlyArray<{ id: string; label: string }> }) {
  if (reeksen.length === 0) return null;

  return (
    <ul className="mt-4 grid grid-cols-1 gap-x-6 gap-y-2 text-xs text-muted-foreground sm:grid-cols-2 xl:grid-cols-3">
      {reeksen.map((reeks, i) => (
        <li className="flex items-start gap-2" key={reeks.id}>
          <span
            aria-hidden
            className="mt-[0.3rem] size-2 shrink-0 rounded-[2px]"
            style={{ backgroundColor: `var(--chart-${i + 1})` }}
          />
          <span className="leading-snug">{reeks.label}</span>
        </li>
      ))}
    </ul>
  );
}
